const CommerceData = [
    {
        id : "1",
        schemeName: "Scheme for market development assistance for small scale industry exporters",
        discription:"The Small Industries Development Organisation was under the control of the ministry, as was the National Small Industries Corporation Limited public sector undertaking). The Small Industries Development Organisation was established in 1954 on the basis of the recommendations of the Ford Foundation. ",
        launchDate: "30 August  2000.",
        AnualFund: "12345"

    },
   {id : "2",
    schemeName: "Acts, regulations and schemes of Commerce Department",
    discription:"The Ministry of Commerce and Industry administers two departments, the Department of Commerce and the Department for Promotion of Industry & Internal Trade. The head of the Ministry is a Minister of Cabinet rank.",
    launchDate: "24 February 2022 ",
    AnualFund: "12345"},

    {id : "2",
    schemeName: "Website of Handloom Development Scheme",
    discription:"National Handloom Development Corporation Limited (NHDC) was set up in February, 1983 by the Government of India as a public sector undertaking under the ambit of Ministry of Textiles, Govt. of India in pursuance of the imperative need for a national level agency to assist the speedy development of the handloom sector with the help of 07 Regional Offices and 32 Branch offices.",
    launchDate: "February 1983 ",
    AnualFund: "12345"},
]

export default CommerceData;

